module.exports = __webpack_public_path__ + "assets/images/chroma-animation_160a6b75b63ccf00d314058fcbc6196b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/chroma-animation.gif
// module id = 238
// module chunks = 0